const brandField = 'filter_brand';
const textQueryField = 'filter_product-line';

const searchByYMMFieldsMap = {
  ['filter_year']: 'Year',
  ['filter_make']: 'Make',
  ['filter_model']: 'Model',
};

const vehicleMakeMapping = {
  gmc: 'GMC',
  ram: 'RAM',
};

export default {
  parsingNeeded() {
    const { search: locationSearch, hash: locationHash } = window.location;

    return (
      locationSearch.includes(textQueryField) ||
      locationSearch.includes(brandField) ||
      locationSearch.includes('filter_make') ||
      !!locationHash
    );
  },
  parse() {
    const { search: locationSearch } = window.location;

    let query;
    const selection = [];

    locationSearch
      .replace('?', '')
      .split('&')
      .forEach((param) => {
        const [field, value] = param.split('=');

        // https://upfitsupply.com/product-category/ladder-racks/truck-ladder-racks/?filter_brand=holman&filter_product-line=the-pro-rack&query_type_brand=or
        if (field === textQueryField) {
          query = value.replaceAll('-', ' ');
        }

        if (field === brandField) {
          selection.push({
            field: 'Brand',
            term: value,
          });
        }

        const ymmField = searchByYMMFieldsMap[field];
        if (ymmField) {
          let processedValue = value.replaceAll('%20', ' ');

          if (ymmField === 'Make') {
            if (Object.keys(vehicleMakeMapping).includes(value)) {
              processedValue = vehicleMakeMapping[processedValue];
            } else {
              processedValue = processedValue
                .split('-')
                .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
                .join('-');
            }
          }

          // https://upfitsupply.com/product-category/safety-security/locks/?filter_brand=slick-locks&filter_make=mercedes-benz&filter_model=Sprinter%202500&filter_year=2023
          selection.push({ field: ymmField, term: processedValue });
        }
      });

    // use JSON.parse(JSON.stringify()) to filter undefined
    return JSON.parse(JSON.stringify({ selection, query }));
  },
};
